import * as React from 'react';
import { Or } from '../../../../../../domain/Or';
import { Style } from '../../../../../Shared/Styles/CSS';

export const Slider = ({ isChecked, backgroundColor }: { isChecked: boolean; backgroundColor?: string }) => {
	backgroundColor = isChecked ? Or(backgroundColor, `goldenrod`) : `dimgray`;

	const sliderInnerCircleStyle = {
		position: 'absolute' as 'absolute',
		content: '""',
		height: '10px',
		width: '10px',
		left: '4px',
		bottom: '4px',
		backgroundColor: `white`,
		transform: `translateX(${isChecked ? 16 : 0}px)`,
		borderRadius: `50%`,
		transition: `all 0.5s`
	};

	const sliderStyle = Style(`slider_${backgroundColor}_${isChecked}`, {
		position: 'absolute',
		cursor: 'pointer',
		top: '0',
		left: '0',
		right: '0',
		bottom: '0',
		borderRadius: `34px`,
		backgroundColor,
		transition: `all 1s`,
		':before': sliderInnerCircleStyle,
		':focus': {
			boxShadow: `0 0 1px ${backgroundColor}`
		}
	});

	return <span id="slider" {...sliderStyle} />;
};